import React, {useContext} from 'react';
import AuthContext from "../context/AuthProvider";
import {Link, Navigate} from "react-router";
import {Helmet} from "react-helmet";
import kocak from "../assets/kocak.jpg";
import FraudioLoader from "./FraudioLoader";

function KocakGold(props) {
    const { auth } = useContext(AuthContext);

    if (auth !== "kocakgold@audiotime.com.tr") {
        return <Navigate to="/giris" />;
    }

    return (
        <React.Fragment>
            <Helmet>
                <script src={`${process.env.PUBLIC_URL}/assets/js/fraudio.min.js`} type="text/javascript"/>
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/assets/css/fraudio.css`}/>
            </Helmet>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
                                <span className="breadcumb__title">
                                    <span className="breadcumb__title-lighten"
                                          style={{color: "#0a0a0a"}}>KOÇAK GOLD</span> DEMO
                                </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">KOÇAK GOLD</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div className="live-youtube-wrapper style-two pb-120 pt-60 mt-0">
                <div className="container">
                    <div className="live-youtube style-two">
                        <div className="row gy-4 align-items-center">
                            <div className="col-lg-4">
                                <div className="youtube-rj">
                                    <div className="youtube-rj__thumb">
                                        <img src={kocak} alt="kampanya"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="youtube-content">
                                            <h6 className="youtube-content__subtitle">Altın Piyasası</h6>
                                            <h2 className="youtube-content__title" style={{color: "#fff"}}>
                                                Anlık Altın Piyasası
                                            </h2>
                                            <p className="youtube-content__desc">
                                                Altın piyasası hakkında anlık bilgi verir ve yapay zeka ile piyasa durumunu sunar.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-lg-0 mt-3">
                                        <FraudioLoader src="https://audiotime.clerkai.app/kocak.php"
                                                       title="Kocak Gold" artist="Altın Piyasası"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default KocakGold;